const BaseURL = {
	LOCAL_BASE_URL: process.env.REACT_APP_API_URL,
	SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
};

export default BaseURL;
